<!--
@Create By Tim For 19/08/14
@全部课程组件
-->
<template>
  <div class="AllCourse" v-loading="loading">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>在线课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ categoryLabel }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ categoryLabels }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- TABS切换 -->
    <div class="tabs">
      <el-tabs @tab-click="changeTabs">
        <el-tab-pane label="全部课程" name="all"></el-tab-pane>
        <el-tab-pane v-for="(item, index) in catalogList" :key="index" :label="item.categoryLabel" :name="item.id" :id="item.id">
          <div class="tabList" v-if="item.children.length === 0">无</div>
          <div class="tabList" v-else>
            <el-tabs v-model="categoryId" @tab-click="changeTab">
              <el-tab-pane v-for="(items, indexs) in item.children" :key="indexs" :label="items.categoryLabel" :name="items.id" :id="items.id"></el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 课程列表 -->
    <div class="courseList">
      <el-row :gutter="20" style="min-height: 500px;">
        <el-col :span="4" v-for="(item, index) in courseData" :key="index">
          <a href="javascript:;" @click="goToInfo(item)">
            <el-card class="box-card" shadow="hover">
              <div class="cardImg">
                <el-image fit="fill" :lazy="true" style="width:221px;height:140px;" :src="item.coursePicUrl">
                  <div slot="placeholder" class="placeholder">封面加载中...</div>
                </el-image>
              </div>
              <p class="title">{{ item.courseName }}</p>
              <p class="tip">{{ grade(item.courseGrade) }} | {{ item.chapterCount }}节课</p>
            </el-card>
          </a>
        </el-col>

        <!-- 暂无数据 -->
        <div class="dataNull" v-if="!pagination">未查询到相关内容</div>
      </el-row>

      <!-- 课程分页组件 -->
      <div class="pagination" v-if="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totals"
          @current-change="currentChange"
          @prev-click="prevClick"
          @next-click="nextClick"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../../../config/api';
import CourseList from './CourseList';
import Bus from '../../bus';

export default {
  name: 'AllCourse',
  data() {
    return {
      // 分类选择
      categoryId: 'all',
      // 课程分类数据
      catalogList: [],
      // 课程名称
      courseName: '',
      // 是否显示分页
      pagination: false,
      // 课程列表集合
      courseData: [],
      // 当前页
      currentPage: 1,
      // 每页显示几条
      pageSize: 24,
      // 数据总条数
      totals: 0,
      loading: false,
      categoryLabel: '',
      categoryLabels: ''
    };
  },

  created() {},

  mounted() {
    this.getCatalog();
    this.getCourseList();
    // 查询是否是从首页导航直接跳转进来的
    this.queryStatus();
  },

  methods: {
    // 选择一级课程
    changeTabs(tab, event) {
      this.categoryLabel = tab.label;
      this.categoryLabels = '';
    },
    // 选择课程
    changeTab(tab, event) {
      this.categoryId = tab.name;
      this.$route.params.category = tab.name;
      this.categoryLabels = tab.label;
      this.getCourseList();
    },

    // 获取课程分类
    getCatalog() {
      let category = this.$route.params.category;
      this.$axios.get(api + 'portal/category/list').then(res => {
        if (res) {
          this.catalogList = res;
          if (category) {
            for (var i = 0; i < res.length; i++) {
              if (category == res[i].id) {
                this.categoryLabel = res[i].categoryLabel;
              }
            }
          } else {
            this.categoryLabel = '全部课程';
          }
        }
      });
    },

    // 查询是否是从首页导航直接跳转进来的
    queryStatus() {
      if (this.$route.params.category) {
        this.categoryId = this.$route.params.category;
      }
    },

    // 获取课程列表
    getCourseList() {
      let category = this.$route.params.category;
      let courseName = this.$route.query.courseName;
      if (category) {
        this.categoryId = category;
      } else if (courseName || courseName == '') {
        this.courseName = courseName;
        // console.log('courseName', this.courseName)
      }
      this.getData();
    },

    // 课程请求方法
    getData() {
      this.loading = true;
      this.$axios
        .get(api + 'portal/course/list?courseCategoryId=' + this.categoryId + '&pageNum=' + this.currentPage + '&pageSize=' + this.pageSize + '&courseName=' + this.courseName)
        .then(res => {
          this.loading = false;
          if (res && res.rows.length > 0) {
            this.pagination = true;
            this.courseData = res.rows;
            this.totals = res.total;
          } else {
            this.pagination = false;
            this.courseData = [];
          }
        });
    },

    // 过滤课程级别
    grade(data) {
      if (data === 1) {
        return '初级';
      } else if (data === 2) {
        return '中级';
      } else if (data === 3) {
        return '高级';
      }
    },

    // 点击页码
    currentChange(val) {
      this.currentPage = val;
      this.getCourseList();
    },

    // 点击上一页
    prevClick(val) {
      this.getCourseList();
    },

    // 点击下一页
    nextClick(val) {
      this.getCourseList();
    },

    // 进入详情页
    goToInfo(data) {
      let res = {
        label: this.categoryLabel,
        id: this.categoryId
      };
      window.sessionStorage.setItem('nav', JSON.stringify(res));
      this.$router.push({ path: '/CourseInfo/' + data.id });
    }
  },

  components: {
    CourseList
  },

  watch: {
    $route(newval, oldval) {
      if (newval) {
        this.getCourseList();
      }
    }
  }
};
</script>

<style>
.AllCourse .el-tabs__nav-wrap::after {
  height: 0;
}
.AllCourse .el-tabs__active-bar {
  height: 0;
}

.AllCourse .el-tabs {
  float: left;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.AllCourse .el-card__body {
  padding: 0;
}

.AllCourse .tabs .el-tabs__header {
  margin: 0;
}
</style>

<style scoped>
.AllCourse .title {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #000;
  width: 1440px;
  margin: 0 auto;
}

.AllCourse .tabs {
  height: 38px;
  line-height: 40px;
  font-size: 14px;
  border-top: 1px solid #d3d3d3;
  border-bottom: 1px solid #d3d3d3;
  width: 1440px;
  margin: 0 auto;
}

.AllCourse .tabs span {
  float: left;
  color: #666;
  margin-right: 40px;
}

.AllCourse .AllCourse {
  padding: 20px 0;
}

.AllCourse .box-card {
  margin-bottom: 20px;
}

.AllCourse .cardImg {
  width: 221px;
  height: 140px;
}

.AllCourse .cardImg img {
  width: 221px;
  height: 140px;
}

.box-card .title {
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.AllCourse .tip {
  height: 20px;
  padding: 0 5px;
  line-height: 20px;
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
}

.AllCourse .pagination {
  margin: 20px 0;
  text-align: center;
}

.AllCourse .placeholder {
  width: 221px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

.AllCourse .dataNull {
  height: 300px;
  width: 100%;
  line-height: 300px;
  font-size: 16px;
  text-align: center;
  color: #666;
}

.AllCourse a {
  text-decoration: none;
}

.AllCourse .courseList {
  width: 1440px;
  margin: 30px auto;
}

.AllCourse .tabList {
  width: 1440px;
  height: 38px;
  line-height: 38px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/AllCourse/AllCourse.vue